import { mutationNames } from '@/store/storeKey'
import * as storage from '@/modules/storage'

const state = {
  loading: true,
  // activeDevice: storage.activeDevice.get() || 'devsimiPhone6',
  activeDevice: 'devsimiPhone6',
  deleteModuleDialogVisible: false,
  subscriptionModuleIdToDelete: 0,
  moduleId: 0,
  bannerShow: false,
  selectedActiveDevice: false,
  Devsimloaded: false
}

const getters = {
  loading: state => state.loading,
  activeDevice: state => state.activeDevice,
  selectedActiveDevice: state => state.selectedActiveDevice,
  deleteModuleDialogVisible: state => state.deleteModuleDialogVisible,
  subscriptionModuleIdToDelete: state => state.subscriptionModuleIdToDelete,
  moduleId: state => state.moduleId,
  bannerShow: state => state.bannerShow,
  Devsimloaded: state => state.Devsimloaded
}

const mutations = {
  [mutationNames.SET_LOADER] (state, payload) {
    state.loading = payload
  },
  [mutationNames.SET_DEVICE] (state, activeDevice) {
    state.activeDevice = activeDevice
  },
  SET_DELETE_MODULE_DIALOG_VISIBILITY (state, visibility) {
    state.deleteModuleDialogVisible = visibility
  },
  SET_SUBSCRIPTION_MODULE_ID_TO_DELETE (state, idToDelete) {
    state.subscriptionModuleIdToDelete = idToDelete
  },
  SET_MODULE_ID_TO_DELETE (state, moduleId) {
    state.moduleId = moduleId
  },
  SET_ACTIVEDEVICE (state, payload) {
    state.selectedActiveDevice = payload
  },
  SET_BANNER (state, payload) {
    state.bannerShow = payload
  },
  [mutationNames.SET_DEVSIM_LOADED] (state, payload) {
    state.Devsimloaded = payload
  }
}

const actions = {

  showLoader ({ commit }) {
    commit(mutationNames.SET_LOADER, true)
  },

  hideLoader ({ commit }) {
    commit(mutationNames.SET_LOADER, false)
  },

  changeDevice ({commit}, activeDevice) {
    storage.activeDevice.set(activeDevice)
    commit(mutationNames.SET_DEVICE, activeDevice)
  },
  setDevice ({commit}, selDevice) {
    commit(mutationNames.SET_ACTIVEDEVICE, selDevice)
  },
  showDeleteModuleDialog ({ commit }, {
    Id,
    ModuleId
  }) {
    commit('SET_SUBSCRIPTION_MODULE_ID_TO_DELETE', Id)
    commit('SET_MODULE_ID_TO_DELETE', ModuleId)
    commit('SET_DELETE_MODULE_DIALOG_VISIBILITY', true)
  },

  hideDeleteModuleDialog ({ commit }) {
    commit('SET_SUBSCRIPTION_MODULE_ID_TO_DELETE', 0)
    commit('SET_MODULE_ID_TO_DELETE', 0)
    commit('SET_DELETE_MODULE_DIALOG_VISIBILITY', false)
  },
  setBannerstate ({ commit }, payload) {
    commit('SET_BANNER', payload)
  },
  setDevsimloadedA ({
    commit
  }, payload) {
    commit(mutationNames.SET_DEVSIM_LOADED, payload)
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js